<template>
  <div>
    <template v-if="instanceList.length === 0">
      <EmptyMessage>
        There are no root level Annotations in the Annotation Set that you selected that cover
        <VerseReference>{{ contextualizedUsfmRef || '' }}</VerseReference
        >. Please select a different Annotation Set or navigate to a new passage.
      </EmptyMessage>
    </template>
    <template v-else>
      <div>Please choose a root annotation instance for the passage</div>
      <ul>
        <li v-for="instance in instanceList" :key="instance.uri">
          <a href="#" @click.prevent="$emit('selectInstance', instance.uri)">{{
            instance.label || instance.uri
          }}</a>
        </li>
      </ul>
    </template>
  </div>
  <button @click="$emit('back')">Back</button>
</template>

<script setup>
  import EmptyMessage from '../../components/EmptyMessage.vue';
  import VerseReference from './VerseReference.vue';

  defineProps({
    instanceList: {
      type: Array,
      default: () => [],
    },
    contextualizedUsfmRef: {
      type: String,
      default: '',
    },
  });
  defineEmits(['selectInstance', 'back']);
</script>
